module.exports = __webpack_public_path__ + "img/title-img.bfb41232.png";